import {
  MANAGE_USERS_ADD,
  MANAGE_USERS_CLEAN_USER_NOTIFICATIONS,
  MANAGE_USERS_IDENTIFIER,
  SUBSCRIPTIONS_OWNERS,
} from "@shared/services/tour/urls/dashboard-urls.ts";
import { TourUrlMapping } from "@shared/types/localTypes/tour.ts";
import addUser from "@shared/services/tour/mockedApis/manageUsers/addUser.ts";
import genericEmptyResponse from "@shared/services/tour/mockedApis/generic/genericEmptyResponse.ts";
import editUser from "@shared/services/tour/mockedApis/manageUsers/editUser.ts";
import getOwners from "@shared/services/tour/mockedApis/manageUsers/getOwners.ts";

export default {
  [MANAGE_USERS_ADD]: (data) => addUser(data),
  [MANAGE_USERS_CLEAN_USER_NOTIFICATIONS]: () => genericEmptyResponse(),
  [MANAGE_USERS_IDENTIFIER]: (data, config) => {
    if (config?.method === "DELETE") {
      return genericEmptyResponse();
    }
    if (config?.method === "PUT") {
      return editUser(data);
    }

    return genericEmptyResponse();
  },
  [SUBSCRIPTIONS_OWNERS]: () => getOwners(),
} satisfies TourUrlMapping;
